import { TemplatePageFormValues, TemplatePageType } from "./templatePageForm";
import { composeValidators, isImage, isNonNegativeNumber, isNumber, isUrl, maxChar, required, requiredAllowZero, Validator } from "./validators";

/** フィールド名のタイポをコンパイル時に検出できるよう、キーをフォームの値に限定する */
type ValidateRules = Partial<Record<keyof TemplatePageFormValues, Validator>>

/** モーダル側（エディタの外）のフィールド */
const buildFrameRules = (templatePageType: TemplatePageType): ValidateRules => {
  const rules: ValidateRules = {}
  if (templatePageType === 'inviter' || templatePageType === 'guest') {
    rules.startDate = required
    rules.endDate = required
  }
  if (templatePageType === 'guest') {
    rules.guest_limit = composeValidators(requiredAllowZero, isNonNegativeNumber)
  }
  return rules
}

const COMMON_EDITOR_RULES: ValidateRules = {
  template_type: required,
  target_cv_num: composeValidators(required, isNumber),
  pageDescription: maxChar(50),
  logo: composeValidators(required, isImage),
  incentive_action: composeValidators(required, maxChar(30)),
  incentive_content: composeValidators(required, maxChar(30)),
  incentive_amount: maxChar(10),
  incentive_image: isImage,
  incentive_content_guest: composeValidators(required, maxChar(30)),
  incentive_amount_guest: maxChar(10),
  incentive_image_guest: isImage,
  notice: composeValidators(required, maxChar(500)),
  terms: composeValidators(isUrl, maxChar(100)),
  privacy_policy: composeValidators(required, isUrl, maxChar(100)),
  line_message: composeValidators(required, maxChar(200)),
}

const INVITER_EDITOR_RULES: ValidateRules = {
  pageDescription: maxChar(50),
  key_visual: isImage,
  key_visual_text: maxChar(30),
}

const GUEST_EDITOR_RULES: ValidateRules = {
  pageDescription: maxChar(50),
  key_visual: isImage,
  key_visual_text: maxChar(30),
  link_text: maxChar(200),
  link_url: composeValidators(required, isUrl, maxChar(100)),
  flow_text: maxChar(500),
}

const EDITOR_RULES: Record<TemplatePageType, ValidateRules> = {
  common: COMMON_EDITOR_RULES,
  inviter: INVITER_EDITOR_RULES,
  guest: GUEST_EDITOR_RULES,
}

/**
 * templatePageType に応じた @mantine/form の validate を組み立てる。
 * 1つのフォームで3種類を兼ねるため、表示していないフィールドのルールは混ぜない
 */
export const buildValidate = (templatePageType: TemplatePageType): ValidateRules => ({
  ...buildFrameRules(templatePageType),
  ...EDITOR_RULES[templatePageType],
})
